export enum ConversationResponseGetJwtError {
  conversationConfigMissing = 'conversationConfigMissing',
  unableToCreateConversationUser = 'unableToCreateConversationUser',
  unableToUpdateConversationUser = 'unableToUpdateConversationUser',
  unableToCreateChatAccessToken = 'unableToCreateChatAccessToken',
}
